module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'filnbf62',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
